import { Text, useStyleConfig } from '@tectonic/elemason-components';
import { Countdown } from '../../components';
import { isVisible } from '../../utils';

import type {
  CountdownData,
  ElemasonCountdownProductListWidgetHeaderConfig,
  ElemasonCountdownProductListWidgetHeaderData,
} from '@tectonic/types';
import type { FC } from 'react';

type CountdownProductListHeaderProps = {
  count?: number;
  isError: boolean;
  isLoading: boolean;
  countdown?: CountdownData;
  onCountdownEnd?: () => void;
  data?: ElemasonCountdownProductListWidgetHeaderData;
  config?: ElemasonCountdownProductListWidgetHeaderConfig;
};

const CountdownProductListHeader: FC<CountdownProductListHeaderProps> = ({
  data,
  config,
  countdown,
  onCountdownEnd,
}) => {
  const { title, subtitle } = data ?? {};

  const showTitle = isVisible(config?.title ?? {});
  const showSubtitle = isVisible(config?.subtitle ?? {});

  const containerProps = useStyleConfig(config?.container ?? {});

  return (
    <div {...containerProps}>
      <div className="flex flex-row items-center">
        <div className="grow">
          {showTitle && <Text data={title} config={config?.title} />}
        </div>
        <Countdown
          target={countdown}
          config={config?.countdown}
          onCountdownEnd={onCountdownEnd}
        />
      </div>
      {showSubtitle && subtitle && (
        <Text data={subtitle} config={config?.subtitle} />
      )}
    </div>
  );
};

CountdownProductListHeader.displayName = 'ElemasonCountdownProductListHeader';

export { CountdownProductListHeader };
